import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class CtaContact {
    constructor(root) {
        this.root = root;
        this.title = this.root.querySelector('[data-cta-contact--title]');
        this.btn = this.root.querySelectorAll('[data-cta-contact--btn]');
        
        this.init();
    }

    init() {
        this.anim = gsap.timeline({
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                // markers: true,
            },
        })
            .fromTo(this.title, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start')
            .fromTo(this.btn, {
                opacity: 0,
                xPercent: -20,
            }, {
                opacity: 1,
                xPercent: 0,
                duration: 0.7,
                stagger: 0.1,
                ease: 'out',
            }, '#start+=0.1');
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-cta-contact]').length > 0;
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-cta-contact]').forEach(root => {
            const instance = new CtaContact(root);
            this.instances.push([]);
        });
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
